<template>
  <FormModal
    :visible="showModalCreate"
    :title="
      representante.Guid ? 'Editar representante' : 'Adicionar representante'
    "
    :icon="require('@/assets/addRepresentante.png')"
    :loading="disableBtn"
    :confirm-label="representante.Guid ? 'Atualizar' : 'Adicionar'"
    @update:visible="handleClose"
    @confirm="salvarRepresentante"
    @cancel="handleClose"
  >
    <form @submit.prevent="salvarRepresentante">
      <!-- SUBSECTION: Dados Pessoais -->
      <div class="form-subsection">
        <h4 class="form-subsection-title">
          <i class="fa fa-user"></i>
          Dados Pessoais
        </h4>

        <div class="form-grid-1">
          <div class="form-field">
            <label class="form-field-label form-field-label-required"
              >Selecione tipo</label
            >
            <ModalSelect
              class="field"
              v-model="representante.Tipo"
              @change="handleTipoChange"
              :options="[{'id':'','descricao':'Selecione'},{'id':'Representante','descricao':'Representante'},{'id':'Pessoa autorizada emitir ordem','descricao':'Autorizado a emitir ordens'}]"
              title="Tipo de representante"
              placeholder="Selecione"
            />
            <p v-if="camposObrigatorios.erroTipo" class="form-field-error">
              Campo obrigatório
            </p>
          </div>
        </div>

        <div class="form-grid-1">
          <div class="form-field">
            <InputNome
              v-model="representante.Nome"
              label="Nome"
              :required="true"
              :erro="camposObrigatorios.erroNome"
            />
          </div>
        </div>

        <div class="form-grid-2">
          <div class="form-field">
            <label class="form-field-label form-field-label-required"
              >Tipo de Documento</label
            >
            <ModalSelect
              class="field"
              v-model="representante.TipoDocumento"
              @change="aoMudarTipoDocumento"
              :options="[{'id':'','descricao':'Selecione'},{'id':'CPF','descricao':'CPF'},{'id':'CNPJ','descricao':'CNPJ'},{'id':'CNH','descricao':'CNH'},{'id':'RNE','descricao':'RNE'}]"
              title="Tipo de documento"
              placeholder="Selecione"
            />
            <p
              v-if="camposObrigatorios.erroTipoDocumento"
              class="form-field-error"
            >
              Campo obrigatório
            </p>
          </div>
          <div class="form-field">
            <label class="form-field-label form-field-label-required">{{
              obterLabelDocumento
            }}</label>
            <input
              type="text"
              class="field"
              autocomplete="off"
              v-model="representante.CpfCnpj"
              v-mask="obterMascaraDocumento"
              :placeholder="obterPlaceholderDocumento"
              @change="validarDocumento"
            />
            <p v-if="camposObrigatorios.erroCpfCnpj" class="form-field-error">
              Campo obrigatório
            </p>
            <p v-if="erroDocumento" class="form-field-error">
              {{ mensagemErro }}
            </p>
          </div>
        </div>

        <div class="form-grid-2">
          <div class="form-field">
            <label class="form-field-label form-field-label-required"
              >E-mail</label
            >
            <input
              type="text"
              class="field"
              autocomplete="off"
              v-model="representante.Email"
              @blur="validarEmail"
            />
            <p v-if="emailErros.email" class="form-field-error">
              {{ emailErros.email }}
            </p>
          </div>
          <div class="form-field">
            <telefone-internacional
              v-model="representante.Telefone"
              label="Telefone"
              name="Telefone"
              @validate="onValidateTelefone"
            />
            <p v-if="camposObrigatorios.erroTelefone" class="form-field-error">
              Campo obrigatório
            </p>
          </div>
        </div>

        <div v-if="exibirCargo" class="form-grid-1">
          <div class="form-field">
            <label class="form-field-label form-field-label-required"
              >Cargo</label
            >
            <input
              type="text"
              class="field"
              autocomplete="off"
              v-model="representante.Cargo"
            />
            <p v-if="camposObrigatorios.cargo" class="form-field-error">
              Campo obrigatório
            </p>
          </div>
        </div>
      </div>

      <div class="form-subsection-divider"></div>

      <!-- SUBSECTION: Informações Regulatórias -->
      <div class="form-subsection">
        <h4 class="form-subsection-title">
          <i class="fa fa-shield"></i>
          Informações Regulatórias
        </h4>

        <div class="form-grid-1">
          <div class="form-field">
            <label class="form-field-label form-field-label-required"
              >Assinatura</label
            >
            <ModalSelect
              class="field"
              v-model="representante.Assinatura"
              :disabled="
                representante.Tipo === 'Pessoa autorizada emitir ordem'
              "
              :options="listaAssinaturas"
              title="Assinatura"
              placeholder="Selecione"
            />
            <p
              v-if="camposObrigatorios.erroAssinatura"
              class="form-field-error"
            >
              Campo obrigatório
            </p>
          </div>
        </div>

        <div class="form-grid-2">
          <div class="form-field">
            <label class="form-field-label form-field-label-required"
              >É considerado US Person?</label
            >
            <div class="form-radio-group">
              <label class="form-radio-item">
                <input
                  type="radio"
                  value="false"
                  name="usPerson"
                  class="form-radio-input"
                  v-model="representante.UsPerson"
                />
                <span class="form-radio-label">Não</span>
              </label>
              <label class="form-radio-item">
                <input
                  type="radio"
                  value="true"
                  name="usPerson"
                  class="form-radio-input"
                  v-model="representante.UsPerson"
                />
                <span class="form-radio-label">Sim</span>
              </label>
            </div>
          </div>
          <div class="form-field">
            <label class="form-field-label form-field-label-required"
              >É uma Pessoa Exposta Politicamente?</label
            >
            <div class="form-radio-group">
              <label class="form-radio-item">
                <input
                  type="radio"
                  value="false"
                  name="politicamenteExposta"
                  class="form-radio-input"
                  v-model="representante.PoliticamenteExposta"
                />
                <span class="form-radio-label">Não</span>
              </label>
              <label class="form-radio-item">
                <input
                  type="radio"
                  value="true"
                  name="politicamenteExposta"
                  class="form-radio-input"
                  v-model="representante.PoliticamenteExposta"
                />
                <span class="form-radio-label">Sim</span>
              </label>
            </div>
          </div>
        </div>

        <div v-if="configuracaoResponsavelPorLogin" class="form-grid-1">
          <div class="form-field">
            <label class="form-field-label form-field-label-required"
              >Será o responsável pelo login?</label
            >
            <div class="form-radio-group">
              <label class="form-radio-item">
                <input
                  type="radio"
                  value="false"
                  name="responsavelLogin"
                  class="form-radio-input"
                  v-model="representante.ResponsavelLogin"
                  :disabled="
                    representante.Tipo === 'Pessoa autorizada emitir ordem' ||
                    existeResponsavelLogin ||
                    !configuracaoResponsavelPorLogin
                  "
                />
                <span class="form-radio-label">Não</span>
              </label>
              <label class="form-radio-item">
                <input
                  type="radio"
                  value="true"
                  name="responsavelLogin"
                  class="form-radio-input"
                  v-model="representante.ResponsavelLogin"
                  :disabled="
                    representante.Tipo === 'Pessoa autorizada emitir ordem' ||
                    existeResponsavelLogin ||
                    !configuracaoResponsavelPorLogin
                  "
                />
                <span class="form-radio-label">Sim</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </form>
  </FormModal>

  <ModalAlerta
    :mostrar="modalAlerta.mostrar"
    :tipo="modalAlerta.tipo"
    :titulo="modalAlerta.titulo"
    :mensagem="modalAlerta.mensagem"
    @fechar="modalAlerta.mostrar = false"
  />
</template>

<script>
import { listaAssinaturas } from "@/constants/pjCadastroOpcoes";
import ModalSelect from "@/components/ModalSelect.vue";
import { mapGetters, mapActions } from "vuex";
import api from "@/api/axios";
import emailValidatorMixin from "@/utils/emailValidatorMixin.js";
import { mask } from "vue-the-mask";
import documentoUtils from "@/utils/documentoUtils";
import FormModal from "@/components/FormModal.vue";
import ModalAlerta from "../Utilitarios/ModalAlerta.vue";

export default {
  components: {
    ModalSelect,
    FormModal,
    ModalAlerta,
  },
  directives: {
    mask,
  },
  computed: {
    listaAssinaturas() {
      return listaAssinaturas;
    },
    ...mapGetters({
      showModalCreate: "GET_MODAL_PJ_ADD_PESSOA",
      editarRepresentante: "GET_MODAL_PJ_EDITAR_PESSOA",
      user: "auth/user",
      existeResponsavelLogin: "existeResponsavelLogin",
      getConfiguracoes: "GET_CONFIGURACOES",
    }),
    celularMask() {
      const telefoneLimpo = this.representante.Telefone?.replace(/\D/g, "");
      if (telefoneLimpo?.length <= 11) {
        return "(##) #####-####";
      } else {
        return "+(##) (##) ####-#####";
      }
    },
    // Computed properties para o documento
    obterLabelDocumento() {
      if (!this.representante || !this.representante.TipoDocumento)
        return "CPF";
      return documentoUtils.obterLabelDocumento(
        this.representante.TipoDocumento,
      );
    },
    obterMascaraDocumento() {
      if (!this.representante || !this.representante.TipoDocumento)
        return "###.###.###-##";
      return documentoUtils.obterMascaraDocumento(
        this.representante.TipoDocumento,
      );
    },
    obterPlaceholderDocumento() {
      if (!this.representante || !this.representante.TipoDocumento)
        return "000.000.000-00";
      return documentoUtils.obterPlaceholderDocumento(
        this.representante.TipoDocumento,
      );
    },
  },
  mixins: [emailValidatorMixin],
  data() {
    return {
      modalAlerta: {
        mostrar: false,
        tipo: "warning",
        titulo: "",
        mensagem: "",
      },
      emailErros: {},
      telefoneValido: [],
      exibirCargo: false,
      permitirAvancar: false,
      configuracaoResponsavelPorLogin: false,
      camposObrigatorios: {
        erroTipo: false,
        erroNome: false,
        erroCargo: false,
        erroCpfCnpj: false,
        erroTipoDocumento: false,
        erroEmail: false,
        erroTelefone: false,
        erroAssinatura: false,
      },
      erroDocumento: false,
      mensagemErro: "",
      disableBtn: false,
      representante: {
        Guid: "",
        Nome: "",
        Email: "",
        Cargo: "",
        CpfCnpj: "",
        TipoDocumento: "CPF", // Adicionado o campo de tipo de documento
        UsPerson: false,
        PoliticamenteExposta: false,
        ResponsavelLogin: false,
        Tipo: "",
        Telefone: "",
        Assinatura: "",
      },
    };
  },
  async mounted() {
    await this.fetchConfiguracao(["Exibir pergunta - Responsável pelo login?"]);
    await this.fetchConfiguracao(["Exibir cargo em representante"]);
    this.disableBtn = false;

    this.exibirCargo =
      this.getConfiguracoes("Exibir cargo em representante")?.Valor == "N"
        ? false
        : true;
    this.configuracaoResponsavelPorLogin =
      this.getConfiguracoes("Exibir pergunta - Responsável pelo login?")
        ?.Valor == "N"
        ? false
        : true;
  },
  watch: {
    editarRepresentante() {
      this.representante = this.editarRepresentante;

      if (!this.representante.TipoDocumento) {
        this.representante.TipoDocumento = "CPF";
      }

      if (!this.configuracaoResponsavelPorLogin && this.representante) {
        this.representante.ResponsavelLogin = false;
      }
    },
    showModalCreate() {
      if (!this.showModalCreate) {
        this.limparObj();
      }
    },
  },
  methods: {
    ...mapActions({
      fetchConfiguracao: "FETCH_CONFIGURACOES",
    }),
    onValidateTelefone({ name, valid }) {
      if (!this.telefoneValido) {
        this.telefoneValido = {};
      }
      if (valid != "undefined") {
        this.telefoneValido[name] = valid;
      }
    },
    validarEmail() {
      this.validarEmailGeneric(this.representante.Email, "email", {
        obrigatorio: true,
      });
    },
    // Método para mudar o tipo de documento
    aoMudarTipoDocumento() {
      if (!this.representante) return;

      // Limpa o campo de documento quando o tipo muda
      this.$set(this.representante, "CpfCnpj", "");
      this.erroDocumento = false;
      this.mensagemErro = "";
    },
    // Método para validar o documento
    validarDocumento() {
      if (!this.representante) return;

      if (this.representante.CpfCnpj) {
        const resultado = documentoUtils.validarDocumentoCompleto(
          this.representante.CpfCnpj,
          this.representante.TipoDocumento || "CPF",
        );
        this.erroDocumento = !resultado.valido;
        this.mensagemErro = resultado.mensagem;

        // Se o documento for inválido, volte o foco para o campo
        if (!resultado.valido) {
          this.$nextTick(() => {
            const inputElement = document.querySelector(
              'input[v-model="representante.CpfCnpj"]',
            );
            if (inputElement) {
              inputElement.focus();
            }
          });
        }
      } else {
        this.erroDocumento = false;
        this.mensagemErro = "";
      }
    },
    handleTipoChange() {
      if (
        this.representante &&
        this.representante.Tipo === "Pessoa autorizada emitir ordem"
      ) {
        this.representante.Assinatura = 1;
        this.representante.ResponsavelLogin = false;
      }
    },
    handleClose() {
      this.limparObj();
      this.$store.commit("SET_MODAL_PJ_ADD_PESSOA", {
        showModal: false,
        existeResponsavel: this.existeResponsavelLogin,
      });
    },
    closeModal() {
      this.handleClose();
    },
    limparObj() {
      this.representante = {
        Guid: "",
        Nome: "",
        Email: "",
        Cargo: "",
        CpfCnpj: "",
        TipoDocumento: "CPF", // Inicializa com CPF
        UsPerson: false,
        PoliticamenteExposta: false,
        ResponsavelLogin: false,
        Tipo: "",
        Assinatura: "",
      };
      this.erroDocumento = false;
      this.disableBtn = false;
      this.mensagemErro = "";
    },
    validarFormulario(submeter) {
      this.permitirAvancar = true;
      var nomeDoCampo = "";
      this.camposObrigatorios = {
        erroTipo: false,
        erroNome: false,
        erroCpfCnpj: false,
        erroCargo: false,
        erroTipoDocumento: false,
        erroEmail: false,
        erroTelefone: false,
        erroAssinatura: false,
      };

      if (this.representante) {
        if (
          this.representante.Tipo === null ||
          this.representante.Tipo === undefined ||
          this.representante.Tipo === ""
        ) {
          if (submeter && this.permitirAvancar) {
            this.camposObrigatorios.erroTipo = true;
            nomeDoCampo = "Tipo";
          }
          this.permitirAvancar = false;
        }

        if (!this.representante.Nome) {
          if (submeter && this.permitirAvancar) {
            this.camposObrigatorios.erroNome = true;
            nomeDoCampo = "Nome";
          }
          this.permitirAvancar = false;
        }

        if (!this.representante.Cargo && this.exibirCargo) {
          if (submeter && this.permitirAvancar) {
            this.camposObrigatorios.erroCargo = true;
            nomeDoCampo = "Cargo";
          }
          this.permitirAvancar = false;
        }

        if (!this.representante.TipoDocumento) {
          if (submeter && this.permitirAvancar) {
            this.camposObrigatorios.erroTipoDocumento = true;
            nomeDoCampo = "Tipo de Documento";
          }
          this.permitirAvancar = false;
        }

        if (!this.representante.CpfCnpj) {
          if (submeter && this.permitirAvancar) {
            this.camposObrigatorios.erroCpfCnpj = true;
            nomeDoCampo = "CPF/CNPJ";
          }
          this.permitirAvancar = false;
        } else if (this.erroDocumento) {
          if (submeter && this.permitirAvancar) {
            this.camposObrigatorios.erroCpfCnpj = true;
            nomeDoCampo = this.obterLabelDocumento;
          }
          this.permitirAvancar = false;
        }

        if (Object.values(this.emailErros).some((erro) => erro !== "")) {
          if (submeter && this.permitirAvancar) {
            this.camposObrigatorios.erroEmail = true;
            nomeDoCampo = "E-mail";
          }
          this.permitirAvancar = false;
        }

        if (!this.representante.Telefone || !this.telefoneValido?.Telefone) {
          if (submeter && this.permitirAvancar) {
            this.camposObrigatorios.erroTelefone = true;
            nomeDoCampo = "Telefone";
          }
          this.permitirAvancar = false;
        }

        if (
          (this.representante.Assinatura === null ||
            this.representante.Assinatura === undefined ||
            this.representante.Assinatura === "") &&
          this.representante.Tipo !== "Pessoa autorizada emitir ordem"
        ) {
          if (submeter && this.permitirAvancar) {
            this.camposObrigatorios.erroAssinatura = true;
            nomeDoCampo = "Assinatura";
          }
          this.permitirAvancar = false;
        }
      }

      if (submeter && nomeDoCampo != "") {
        this.modalAlerta = {
          mostrar: true,
          tipo: "warning",
          titulo: "Atenção: Campo obrigatório",
          mensagem: `O campo ${nomeDoCampo} não foi informado, preencha a informação para avançar.`,
        };
      }
      return this.permitirAvancar;
    },
    // Restante dos métodos sem alteração
    async salvarRepresentante() {
      if (this.validarFormulario(true)) {
        this.disableBtn = true;
        if (this.representante && this.representante.Guid == "") {
          await this.createRepresentante();
        } else {
          await this.updateRepresentante();
        }
      }
    },
    async createRepresentante() {
      await api
        .post("/v2/PessoaJuridica/representante/salvar", this.representante)
        .then((retorno) => {
          if (retorno.status == 200) {
            this.$swal({
              icon: "success",
              title:
                this.representante.Guid == ""
                  ? "Inclusão realizada com sucesso!"
                  : "Alteração realizada com sucesso!",
              text: "Dados informados foram salvos com sucesso.",
            });
            this.$emit("update-success");

            this.limparObj();
            this.$store.commit("SET_MODAL_PJ_ADD_PESSOA", {
              showModal: false,
              existeResponsavel: this.existeResponsavelLogin,
            });
            this.$store.dispatch("FETCH_PJ_LISTA_REPRESENTANTES");
            this.disableBtn = false;

            return true;
          }
        })
        .catch((error) => {
          this.disableBtn = false;
          this.$swal({
            icon: "error",
            title: "Dados informados inválidos informado para representante.",
            text: `${error.response.data.data[0]}`,
          }).then(() => {
            return false;
          });
        });
    },
    async updateRepresentante() {
      await api
        .post("/v2/PessoaJuridica/representante/atualizar", this.representante)
        .then((retorno) => {
          if (retorno.status == 200) {
            this.$swal({
              icon: "success",
              title: "Alteração realizada com sucesso!",
              text: "Dados informados foram atualizados com sucesso.",
            });
            this.$emit("update-success");

            this.limparObj();
            this.$store.commit("SET_MODAL_PJ_ADD_PESSOA", {
              showModal: false,
              existeResponsavel: this.existeResponsavelLogin,
            });
            this.$store.dispatch("FETCH_PJ_LISTA_REPRESENTANTES");
            this.disableBtn = false;

            return true;
          }
        })
        .catch((error) => {
          this.disableBtn = false;
          this.$swal({
            icon: "error",
            title: "Dados informados inválidos informado para representante.",
            text: `${error.response.data.data[0]}`,
          }).then(() => {
            return false;
          });
        });
    },
    // Método helper para salvar alterações
    clear() {
      // Método existente
    },
  },
};
</script>

<style lang="scss" scoped>
// Estilos mínimos - FormModal gerencia a estrutura da modal
</style>
